<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm align-items-center text-sm d-flex justify-content-between catalogo-text"
          >
            Analítica
            <router-link
              :to="
                goBack
                  ? { name: 'AnalyticsChart', params: goBack }
                  : { name: 'AnalyticsPanel' }
              "
            >
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>
          <CCardBody>
            <ChartA v-if="chart.tipo" :chart="chart" :preFiltros="filtros" />
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
export default {
  name: "ChartPage",
  data() {
    return {
      chart: this.$route?.params?.chart || {}
    };
  },
  computed: {
    reporte() {
      return this.$route?.params?.reporte;
    },
    goBack() {
      return this.$route?.params?.goBack||this.$store.getters.goBack;
    },
    filtros() {
      return (
        this.$route?.params?.filtros ||
        this.$store.getters.preFilter[this.reporte]||{}
      );
    }
  },
  created() {
    this.fetchData();
  },
  destroyed () {
    this.$store.dispatch("setPreFilter", {});
    this.$store.dispatch("setGoBack", null);
  },
  mounted () {
    window.onpopstate = this.yourCallBackFunction;
  },
  beforeDestroy () {
    window.onpopstate = null
  },
  watch: {
    "$route.params.filtros"(nV) {
      this.$store.dispatch("setPreFilter", { [this.reporte]: nV });
    },
    "$route.params.goBack"(nV) {
      this.$store.dispatch("setGoBack",  nV );
    },
    reporte() {
      this.chart = this.$route?.params?.chart || {};
      this.fetchData();
    }
  },
  methods: {
    yourCallBackFunction(){
      this.$store.dispatch("setGoBack", this.$route.params.goBack?.goBack||null);
    },
    fetchData() {
      if (!this.chart?.tipo) {
        this.$store
          .dispatch("actMethod", {
            url: "reportes:consultar_app",
            reportes: [this.reporte]
          })
          .then(res => {
            this.chart = res.data[0];
            // if(this.filtros){
            //   console.log(this.chart)
            //   console.log(this.filtros)
            //   debugger
            // }
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
